var map = {
	"./logo_cn_en.svg": 32259,
	"./logo_cn_fr.svg": 33406,
	"./logo_cn_invert_en.svg": 51112,
	"./logo_cn_invert_fr.svg": 59009,
	"./logo_cn_invert_nl.svg": 34223,
	"./logo_cn_nl.svg": 78240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71104;